import { useQuery } from '@tanstack/react-query';
import { paymentPeriodApi } from '../paymentPeriodApi';
import { QueryKey } from '@shared/config';
import { PaginateType } from '@shared/types';

export const useGetPaymentPeriod = () => {
  return useQuery({
    queryKey: [QueryKey.GET_PAYMENT_PERIODS],
    queryFn: () =>
      paymentPeriodApi.getPaymentPeriods({
        paginate: PaginateType.NONE,
        filter: {},
      }),
  });
};
